angular.module('app').directive('hueDbTopColorsExpandedAuto', function () {
  function link(scope, element, attrs) {
  }

  return {
    restrict: 'E',
    templateUrl: 'app/directives/dbTopColorsAuto/dbTopColorsExpandedAutoView.html',
    link: link,
    scope: {
      data: '=',
      toggleView: '&'
    }
  };
});
